import { RedirectValues } from 'types/RedirectItemMenuProps';
export interface ElementMenuItemListProps {
	created_at: string;
	id: string;
	name: string;
	slug: string;
	updated_at: string;
}

export interface FileProps {
	id: string;
	name: string;
	originalname: string;
	mimetype: string;
	size: number;
	key: any | null;
	relativePath: string;
	created_at: string;
	updated_at: string;
	url: string;
}

export interface ItemFromElementMenuProps {
	id: string;
	name: string;
	left_file_id: string | null;
	right_file_id: string | null;
	banner_file_id: string | null;
	active: boolean;
	collapsible: false;
	location_id: string;
	redirect_type: RedirectValues;
	redirect_value: string | null;
	reference_value: string;
	banner_redirect_value: string | null;
	banner_redirect_type: any | null;
	highlighted_color: string | null;
	always_open: boolean;
	menu_item_id: any | null;
	facets: any | null;
	created_at: string;
	updated_at: string;
	file_left: FileProps | null;
	file_right: FileProps | null;
	banner_file: FileProps | null;
	children: ItemFromElementMenuProps[];
}

export const respElementFake: ElementMenuItemListProps[] = [
	{
		created_at: '2025-01-02T13:19:08.068Z',
		id: 'd329360f-9269-4194-81ed-9da627730e1a',
		name: 'elemento 1',
		slug: 'elemento-1',
		updated_at: '2025-01-02T13:19:08.068Z'
	},
	{
		created_at: '2025-01-02T13:19:08.068Z',
		id: 'd329360f-9269-4194-81ed-9da627730e1b',
		name: 'elemento 2',
		slug: 'elemento-2',
		updated_at: '2025-01-02T13:19:08.068Z'
	},
	{
		created_at: '2025-01-02T13:19:08.068Z',
		id: 'd329360f-9269-4194-81ed-9da627730e1c',
		name: 'elemento 3',
		slug: 'elemento-3',
		updated_at: '2025-01-02T13:19:08.068Z'
	}
];

export const respFakeItem: ItemFromElementMenuProps[] = [
	{
		id: '1e730665-e69b-4fb5-a7c9-bd9f9697b227',
		name: 'nome teste',
		left_file_id: '4db862a9-8983-45df-8dde-dcda596585f1',
		right_file_id: '1e803130-e5ce-47aa-af66-32ecc1fae3a7',
		banner_file_id: '69e1edd0-f907-463b-8977-85bd6b8b1e87',
		active: true,
		collapsible: false,
		location_id: 'd329360f-9269-4194-81ed-9da627730e1b',
		redirect_type: 'url',
		redirect_value: 'www.google.com.be',
		reference_value: '',
		banner_redirect_value: 'valor q nao sei',
		banner_redirect_type: null,
		highlighted_color: '#db1f1f',
		always_open: true,
		menu_item_id: null,
		facets: null,
		created_at: '2025-01-02T13:43:40.543Z',
		updated_at: '2025-01-02T13:55:48.409Z',
		file_left: {
			id: '4db862a9-8983-45df-8dde-dcda596585f1',
			name: '1735825418615-default--WhatsApp Image 2024-12-10 at 15.22.58.jpeg',
			originalname: 'default--WhatsApp Image 2024-12-10 at 15.22.58.jpeg',
			mimetype: 'image/jpeg',
			size: 52888,
			key: null,
			relativePath:
				'/superxtra-dev/1735825418615-default--WhatsApp Image 2024-12-10 at 15.22.58.jpeg',
			created_at: '2025-01-02T13:43:38.810Z',
			updated_at: '2025-01-02T13:43:38.810Z',
			url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-dev/1735825418615-default--WhatsApp Image 2024-12-10 at 15.22.58.jpeg'
		},
		file_right: {
			id: '1e803130-e5ce-47aa-af66-32ecc1fae3a7',
			name: '1735825419673-default--1.3-banner-carrossel-principal-natal-mobile.png',
			originalname: 'default--1.3-banner-carrossel-principal-natal-mobile.png',
			mimetype: 'image/png',
			size: 760084,
			key: null,
			relativePath:
				'/superxtra-dev/1735825419673-default--1.3-banner-carrossel-principal-natal-mobile.png',
			created_at: '2025-01-02T13:43:39.863Z',
			updated_at: '2025-01-02T13:43:39.863Z',
			url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-dev/1735825419673-default--1.3-banner-carrossel-principal-natal-mobile.png'
		},
		banner_file: {
			id: '69e1edd0-f907-463b-8977-85bd6b8b1e87',
			name: '1735825420154-default--WhatsApp Image 2024-12-10 at 15.23.01.jpeg',
			originalname: 'default--WhatsApp Image 2024-12-10 at 15.23.01.jpeg',
			mimetype: 'image/jpeg',
			size: 31698,
			key: null,
			relativePath:
				'/superxtra-dev/1735825420154-default--WhatsApp Image 2024-12-10 at 15.23.01.jpeg',
			created_at: '2025-01-02T13:43:40.248Z',
			updated_at: '2025-01-02T13:43:40.248Z',
			url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-dev/1735825420154-default--WhatsApp Image 2024-12-10 at 15.23.01.jpeg'
		},
		children: []
	},
	{
		id: 'b2ed6db4-eb2b-469e-9f28-35ea8d882202',
		name: 'novo teste',
		left_file_id: null,
		right_file_id: 'eac317de-b094-47ba-8d7a-131c0431f49f',
		banner_file_id: null,
		active: false,
		collapsible: false,
		location_id: 'd329360f-9269-4194-81ed-9da627730e1b',
		redirect_type: 'webview',
		redirect_value: 'valor do redirect 1',
		reference_value: '',
		banner_redirect_value: null,
		banner_redirect_type: null,
		highlighted_color: null,
		always_open: false,
		menu_item_id: null,
		facets: null,
		created_at: '2025-01-09T18:01:19.230Z',
		updated_at: '2025-01-09T18:04:11.884Z',
		file_left: null,
		file_right: {
			id: 'eac317de-b094-47ba-8d7a-131c0431f49f',
			name: '1736445851472-default--3.jpg',
			originalname: 'default--3.jpg',
			mimetype: 'image/jpeg',
			size: 15656,
			key: null,
			relativePath: '/superxtra-dev/1736445851472-default--3.jpg',
			created_at: '2025-01-09T18:04:11.587Z',
			updated_at: '2025-01-09T18:04:11.587Z',
			url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-dev/1736445851472-default--3.jpg'
		},
		banner_file: null,
		children: [
			{
				id: 'fd964df6-11c7-4429-abf0-c23cdb957ed1',
				name: 'filho novo teste',
				left_file_id: null,
				right_file_id: null,
				banner_file_id: null,
				active: false,
				collapsible: false,
				location_id: 'd329360f-9269-4194-81ed-9da627730e1b',
				redirect_type: 'url',
				redirect_value: null,
				reference_value: '',
				banner_redirect_value: null,
				banner_redirect_type: null,
				highlighted_color: null,
				always_open: false,
				menu_item_id: 'b2ed6db4-eb2b-469e-9f28-35ea8d882202',
				facets: null,
				created_at: '2025-01-09T18:19:32.933Z',
				updated_at: '2025-01-09T18:19:32.933Z',
				file_left: null,
				file_right: null,
				banner_file: null,
				children: [
					{
						id: '090bb974-ff2a-4fbb-8f26-a223740a400a',
						name: 'netinho',
						left_file_id: null,
						right_file_id: null,
						banner_file_id: null,
						active: false,
						collapsible: false,
						location_id: 'd329360f-9269-4194-81ed-9da627730e1b',
						redirect_type: 'webview',
						redirect_value: null,
						reference_value: '',
						banner_redirect_value: null,
						banner_redirect_type: null,
						highlighted_color: null,
						always_open: false,
						menu_item_id: 'fd964df6-11c7-4429-abf0-c23cdb957ed1',
						facets: null,
						created_at: '2025-01-09T18:46:20.370Z',
						updated_at: '2025-01-09T18:46:20.370Z',
						file_left: null,
						file_right: null,
						banner_file: null,
						children: []
					}
				]
			}
		]
	}
];
